module.exports = "//static.hsappstatic.net/marketing-discovery-utils/static-1.2832/img/studio-announcement.png"